import React from 'react';
import './style.scss';
import { BgMode } from '../index';
import clsx from 'clsx';

interface Props {
  mode: BgMode;
  children: React.ReactNode;
}

const MainContent = ({ mode, children }: Props) => {
  if (mode === 'inactive') return <>{children}</>;

  return (
    <div className={clsx('main-content', `main-content-${mode}`)}>
      {children}
    </div>
  );
};

export default MainContent;
